import type {SerializedGraphNode} from "@cm/graph-v3"
import {deserializeGraphNode} from "@cm/graph-v3"
import {TemplateGraph} from "#template/nodes/template-graph/template-graph"

export const deserializeTemplateGraph = (graphJson: SerializedGraphNode): TemplateGraph => {
    const templateGraph = deserializeGraphNode(graphJson, "template")
    if (!(templateGraph instanceof TemplateGraph)) throw new Error(`Deserialized node is not a TemplateGraph (got ${templateGraph.nodeClass})`)
    return templateGraph
}
